import { useState } from "react";

export default function ProductImage({ src, srcSet, fallbackSrc, onError, ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  const fallback = failedSource === src && !!fallbackSrc;
  return <img {...props} src={fallback ? fallbackSrc : src}
    srcSet={fallback ? undefined : srcSet}
    onError={event => {
      if (!fallback && fallbackSrc) setFailedSource(src);
      onError?.(event);
    }} />;
}
